module.exports = __webpack_public_path__ + "img/memberIcon_gray.20257f13.svg";